<div [innerHTML]="store.lastWorkData() | safeHtml"></div>
